import { AnimatePresence, motion } from "motion/react";
import { useEffect, useMemo, useState } from "react";
import LoadingSpinner from '../Spinner';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./toastify/config";
import Tooltip from "./Tooltip";
import apiCumbres from "../axios/axios";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, TableSortLabel } from "@mui/material";

import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useSelector } from 'react-redux';
import { sxSortColumnTable, sxTableHead, textFieldStyle } from "./Styles";
import ModalPagosPrestmo from "./ModalPagosPrestamo";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Swal from "sweetalert2";



const RevisarPrestamosIndividual = () => {
    const tkn = useSelector((state) => state.tknAuth)
    const [isLoading, setIsLoading] = useState(false)

    const [prestamos, setPrestamos] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [search, setSearch] = useState("");
    const [modalPagosOpen, setModalPagosOpen] = useState(false)
    const [idPrestamoPagos, setIdPrestamoPagos] = useState(null)

    const [orderBy, setOrderBy] = useState('Comienza'); // columna
    const [order, setOrder] = useState('desc');     // asc | desc | null
    const [originalPrestamos, setOriginalPrestamos] = useState([]);

    const obtenerPrestamos = () => {

        const prestamos = async () => {

            try {
                setIsLoading(true)

                const obtener = await apiCumbres.get(`/revisar-prestamos/obtener/${tkn.usuarioId}`)

                setPrestamos(obtener.data)
                setIsLoading(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener préstamos para autorizar, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        }

        prestamos()

    }

    useEffect(() => {
        obtenerPrestamos()
    }, [])

    useEffect(() => {
        setOriginalPrestamos(prestamos);
    }, [prestamos]);

    const formatNumber = (value) => {
        const [intPart, decimalPart] = value.split('.');

        const formattedInt = parseInt(intPart, 10).toLocaleString('en-US');
        return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
    };

    const formatFecha = (value) => {

        const fecha = new Date(value + ' 08:00:00')
        const meses = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE']

        return `${fecha.getDate()} DE ${meses[fecha.getMonth()]} DE ${fecha.getFullYear()}`

    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const verAbonosContrato = (e, id) => {

        //mostrar modal con los pagos, y si ya se pago o no, con las fechas en una tabla
        setIdPrestamoPagos(id)
        setModalPagosOpen(true)

        //hacer template de contrato micro y personal

    }


    const verContrato = (e, id, tc) => {

        const contrato = async () => {

            setIsLoading(true)

            try {
                const obtener = await apiCumbres.get(`/revisar-prestamos/contrato/${id}?tp=I&tc=${tc}`)

                //mandar a abrir el pdf

                // Decodificar base64
                const byteCharacters = atob(obtener.data);
                const byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);

                // ⚠️ MIME TYPE CORRECTO
                const file = new Blob([byteArray], { type: "application/pdf" });

                // Crear URL
                const fileURL = URL.createObjectURL(file);

                // 👉 Abrir en nueva pestaña
                window.open(fileURL, "_blank");
                setIsLoading(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener contrato de préstamo, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        }

        contrato()

    }



    const filteredPrestamos = prestamos.filter(pp =>
        pp.nombrecliente.toLowerCase().includes(search.toLowerCase()) ||
        String(pp.folio).includes(search)
    )

    const cancelarContrato = (e, id) => {

        Swal.fire({
            title: "Estas seguró?",
            text: "No podras revertir el estatus!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, cancelar!"
        }).then(async (result) => {
            if (!result.isConfirmed) return
            setIsLoading(true)
            try {

                const jCancelar = {
                    contratoPrestamoId: id,
                    tp: 'I'
                }

                const cancelContr = await apiCumbres.put('/revisar-prestamos/cancelar', jCancelar)

                Swal.fire({
                    icon: 'success',
                    title: 'Enhorabuena!',
                    text: cancelContr.data.mensaje
                }).then((result) => {
                    window.location.href = '/revisar-prestamos'
                })

                setIsLoading(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al cancelar préstamo, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        });

    }

    const handleRequestSort = (property) => {
        if (orderBy !== property) {
            setOrderBy(property);
            setOrder('asc');
            return;
        }

        if (order === 'asc') {
            setOrder('desc');
            return;
        }

        if (order === 'desc') {
            setOrder(null);
            setOrderBy(null);
            return;
        }

        setOrder('asc');
    };

    const displayedPrestamos = useMemo(() => {
        if (!orderBy || !order) return originalPrestamos;

        return [...filteredPrestamos].sort((a, b) => {
            let aVal = a[orderBy];
            let bVal = b[orderBy];

            if (!isNaN(aVal) && !isNaN(bVal)) {
                return order === 'asc'
                    ? Number(aVal) - Number(bVal)
                    : Number(bVal) - Number(aVal);
            }

            return order === 'asc'
                ? String(aVal).localeCompare(String(bVal), 'es', { numeric: true })
                : String(bVal).localeCompare(String(aVal), 'es', { numeric: true });
        });
    }, [filteredPrestamos, orderBy, order, originalPrestamos]);

    return (
        <div className="container-fluid">
            {isLoading ?
                <LoadingSpinner />
                : null}
            <div className="row">
                <div className="col-md-12">
                    <div
                        className="card shadow-lg  p-5 border-0"
                        style={{ borderRadius: '20px' }}
                    >

                        <div className="row">
                            <motion.h1 className="color-primary"
                                initial={{ opacity: 0, y: -90 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}>
                                Revisar Préstamos Individuales
                            </motion.h1>
                            <hr className="mb-5" />
                            <motion.div
                                key={page}
                                initial={{ opacity: 0, y: 40 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, ease: "easeOut", delay: 0.4 }}

                            >
                                <TextField
                                    label="Buscar prestamo por cliente o folio"
                                    variant="outlined"
                                    size="small"
                                    style={{ width: '35%' }}
                                    className="mb-3 mx-2"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    sx={textFieldStyle}
                                />

                                <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
                                    <Table>
                                        <TableHead >
                                            <TableRow sx={{ backgroundColor: "#0a2540" }}>
                                                <TableCell sx={sxTableHead}>
                                                    <Tooltip text={'ORDENAR'} position="bottom">
                                                        <TableSortLabel
                                                            active={orderBy === 'folio'}
                                                            direction={orderBy === 'folio' && order ? order : 'asc'}
                                                            onClick={() => handleRequestSort('folio')}
                                                            hideSortIcon={orderBy !== 'folio' || !order}
                                                            sx={sxSortColumnTable}
                                                        >
                                                            #
                                                        </TableSortLabel>
                                                    </Tooltip>

                                                </TableCell>
                                                <TableCell sx={sxTableHead} >Cliente</TableCell>
                                                <TableCell sx={sxTableHead}>Prestamista</TableCell>
                                                <TableCell sx={sxTableHead}>Monto</TableCell>
                                                <TableCell sx={sxTableHead}>Pagado</TableCell>
                                                <TableCell sx={sxTableHead}>
                                                    <Tooltip text={'ORDENAR'} position="bottom">
                                                        <TableSortLabel
                                                            active={orderBy === 'fechaComienzaContrato'}
                                                            direction={orderBy === 'fechaComienzaContrato' && order ? order : 'asc'}
                                                            onClick={() => handleRequestSort('fechaComienzaContrato')}
                                                            hideSortIcon={orderBy !== 'fechaComienzaContrato' || !order}
                                                            sx={sxSortColumnTable}
                                                        >
                                                            Comienza
                                                        </TableSortLabel>
                                                    </Tooltip>
                                                </TableCell>
                                                <TableCell sx={sxTableHead}>Primer Pago</TableCell>
                                                <TableCell sx={sxTableHead}>Intereses</TableCell>
                                                <TableCell sx={sxTableHead}>Tipo Préstamo</TableCell>
                                                <TableCell sx={sxTableHead}>Tipo Pago</TableCell>
                                                <TableCell sx={sxTableHead}>Estatus</TableCell>
                                                <TableCell sx={sxTableHead}>Meses</TableCell>
                                                <TableCell sx={sxTableHead}>Pagos</TableCell>
                                                <TableCell sx={sxTableHead}>Contrato</TableCell>
                                                {![1, 4].includes(tkn.rolId) ?
                                                    null
                                                    : <TableCell sx={sxTableHead}>Cancelar</TableCell>
                                                }

                                            </TableRow>
                                        </TableHead>

                                        <TableBody >
                                            <AnimatePresence component={null}>
                                                {displayedPrestamos
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((pp, index) => (
                                                        <motion.tr
                                                            key={index}
                                                            initial={{ opacity: 0, x: -50 }}
                                                            animate={{ opacity: 1, x: 0 }}
                                                            exit={{ opacity: 0, y: -40 }}
                                                            transition={{
                                                                duration: 0.4,
                                                                ease: "easeOut",
                                                                delay: 0.1 * index
                                                            }}
                                                            style={{
                                                                backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"
                                                            }}
                                                        >
                                                            <TableCell sx={{ fontSize: "12px" }}>{String(pp.folio).padStart(5, '0')}</TableCell>
                                                            <TableCell sx={{ fontSize: "12px" }}>{pp.nombrecliente}</TableCell>
                                                            <TableCell sx={{ fontSize: "12px" }}>{pp.nombreusuario}</TableCell>
                                                            <TableCell sx={{ fontSize: "12px" }}>${formatNumber(pp.cantidadPrestar)}</TableCell>
                                                            <TableCell sx={{ fontSize: "12px" }}>${pp.montopagado ? formatNumber(pp.montopagado) : '0.00'}</TableCell>
                                                            <TableCell sx={{ fontSize: "12px" }}>{formatFecha(pp.fechaComienzaContrato)}</TableCell>
                                                            <TableCell sx={{ fontSize: "12px" }}>{formatFecha(pp.fechaPrimerPagoContrato)}</TableCell>
                                                            <TableCell sx={{ fontSize: "12px" }}>{pp.interes}%</TableCell>
                                                            <TableCell sx={{ fontSize: "12px" }}>{pp.tipoPrestamo}</TableCell>
                                                            <TableCell sx={{ fontSize: "12px" }}>{pp.tipoPago}</TableCell>
                                                            <TableCell sx={{ fontSize: "12px" }} className={pp.estatusPrestamo === 'CANCELADO' ? 'text-danger fw-bold' : ''}>{pp.estatusPrestamo}</TableCell>
                                                            <TableCell sx={{ fontSize: "12px" }}>{pp.meses}</TableCell>
                                                            <TableCell sx={{ fontSize: "12px" }}>
                                                                {['EN PROCESO'].includes(pp.estatusPrestamo) ?
                                                                    <Tooltip text={'VER PAGOS'} position="bottom">
                                                                        <RemoveRedEyeIcon className="pointer" onClick={(e) => verAbonosContrato(e, pp.contratoPrestamoId)} />
                                                                    </Tooltip>
                                                                    : 'N/A'

                                                                }
                                                            </TableCell>
                                                            <TableCell sx={{ fontSize: "12px" }}>
                                                                {['LIQUIDADO', 'EN PROCESO'].includes(pp.estatusPrestamo) ?
                                                                    <Tooltip text={'VER CONTRATO'} position="bottom">
                                                                        <RemoveRedEyeIcon className="pointer" onClick={(e) => verContrato(e, pp.contratoPrestamoId, pp.tipoPrestamo)} />
                                                                    </Tooltip>
                                                                    : 'N/A'

                                                                }
                                                            </TableCell>
                                                            {![1, 4].includes(tkn.rolId) ?
                                                                null :
                                                                <TableCell sx={{ fontSize: "12px" }}>
                                                                    {!['CANCELADO'].includes(pp.estatusPrestamo) ?
                                                                        <Tooltip text={'CANCELAR CONTRATO'} position="bottom">
                                                                            <DeleteOutlineIcon className="pointer text-danger" onClick={(e) => cancelarContrato(e, pp.contratoPrestamoId)} />
                                                                        </Tooltip>
                                                                        : 'N/A'}


                                                                </TableCell>
                                                            }
                                                        </motion.tr>
                                                    ))}
                                            </AnimatePresence>
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        component="div"
                                        count={filteredPrestamos.length}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        labelRowsPerPage="Registros por página"
                                        rowsPerPageOptions={[5, 10, 25, 50]}
                                    />
                                </TableContainer>
                            </motion.div>


                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />

            <ModalPagosPrestmo
                open={modalPagosOpen}
                onClose={() => setModalPagosOpen(false)}
                onOpen={() => setModalPagosOpen(true)}
                idp={idPrestamoPagos}
            />
        </div>
    )

}

export default RevisarPrestamosIndividual